import { rosterId } from "../lib/holds.js";

// Shared holds scenario for the Dashboard (?e2e=dashboard&holds=1) and Schedule
// (?e2e=schedule&holds=1) fixtures. The specs pin the browser clock to
// HOLDS_TODAY so the strip (two weeks from Monday) and the month land on these
// dates. Mirrors the quotes fixture's scenario: two hold records share the drone
// and Peter on Oct 7 (one partial, one full); Hold 1102 also holds Oct 17, has a
// flight-only day on Oct 14, and a three-day run Oct 26 to 28; a booked job on
// Oct 6 carries the Canon R5 and John Cushman; a second booked job spans Oct 27
// to 28 with a setup AND a capture on the 27th, carrying the Leica RTC 360 and
// Chris Morel, so it collides with Hold 1102's run and both draw as badged bars.
// Records carry the identity fields every role reads (2026-09-05: clientName,
// subject, contactName, location, isStudio) beside label, dates, equipmentIds,
// and crew. No money anywhere on them.

export const HOLDS_TODAY = "2026-10-05";

export const HOLD_ROSTER = [
  { name: "John Cushman", email: "john@nycap3d.com", phone: "", receivesAllUpdates: true },
  { name: "Peter Richtarech", email: "", phone: "", receivesAllUpdates: false },
  { name: "Chris Morel", email: "", phone: "", receivesAllUpdates: false },
  { name: "Chris Kitchen", email: "", phone: "", receivesAllUpdates: false },
].map(entry => ({ ...entry, id: rosterId(entry) }));

const PETER = { id: "name:peter-richtarech", name: "Peter Richtarech" };
const CHRIS = { id: "name:chris-morel", name: "Chris Morel" };

export const HOLD_RECORDS = [
  {
    id: "q_1000004812", label: "Hold 4812",
    clientName: "Brooks Films", subject: "Rooftop drone survey", contactName: "Mara Brooks", location: "Red Hook, Brooklyn", isStudio: false,
    dates: [{ date: "2026-10-07", dayType: "partial", kinds: ["capture"] }],
    equipmentIds: ["drone"], crew: [PETER],
    fingerprint: "2026-10-07:partial:capture#drone#name:peter-richtarech", updatedAt: "2026-09-01T10:00:00.000Z",
  },
  {
    id: "q_1000001102", label: "Hold 1102",
    clientName: "Nine Twelve Productions, LLC", subject: "Fresh Kills LiDAR survey", contactName: "Dave Sales", location: "Fresh Kills Park, Staten Island", isStudio: false,
    dates: [
      { date: "2026-10-07", dayType: "full", kinds: ["capture"] },
      { date: "2026-10-14", dayType: "full", kinds: ["flight"] },
      { date: "2026-10-17", dayType: "full", kinds: ["capture"] },
      { date: "2026-10-26", dayType: "full", kinds: ["setup"] },
      { date: "2026-10-27", dayType: "full", kinds: ["capture"] },
      { date: "2026-10-28", dayType: "full", kinds: ["strike"] },
    ],
    equipmentIds: ["rtc", "drone"], crew: [PETER, CHRIS],
    fingerprint: "1102", updatedAt: "2026-09-03T10:00:00.000Z",
  },
];

// The admin-only savedQuotes rows by the same ids (crew never receive these).
// Since 2026-09-05 the calendar surfaces read the client off the record itself;
// these rows only feed the Quotes tab and the legacy fallback for a record
// without a clientName field.
export const HOLD_QUOTES = [
  { id: "q_1000004812", clientName: "Brooks Films", contactName: "Mara Brooks", jobStatus: "quoted", total: 4200, grossRevenue: 4200, lineItems: [] },
  { id: "q_1000001102", clientName: "Nine Twelve Productions, LLC", contactName: "Dave Sales", jobStatus: "quoted", total: 23850, grossRevenue: 23850, lineItems: [] },
];

export const HOLD_JOB = {
  id: "j_atl", quoteId: null, clientName: "Atlantic Power Solutions", jobId: "atlpow_261006", clientCode: "atlpow",
  captureDate: "2026-10-06", status: "scheduled", multiDay: false, sessions: [],
  equipment: ["Canon R5"], selectedEquipment: ["Canon R5"], crew: "John Cushman",
  grossRevenue: 3200, invoiced: false, paid: false, locationVenue: "Long Island City",
};

export const HOLD_JOB_2 = {
  id: "j_pier", quoteId: null, clientName: "Pier 59 Studios", jobId: "pier59_261027", clientCode: "pier59",
  status: "scheduled", multiDay: true,
  sessions: [
    { id: "s_pier_setup", sessionType: "setup", date: "2026-10-27", dayType: "full", callTime: "07:00", isStudio: false, locationVenue: "Chelsea Piers" },
    { id: "s_pier_cap", sessionType: "capture", date: "2026-10-27", dayType: "full", callTime: "09:00", isStudio: false, locationVenue: "Chelsea Piers" },
    { id: "s_pier_cap2", sessionType: "capture", date: "2026-10-28", dayType: "full", callTime: "09:00", isStudio: false, locationVenue: "Chelsea Piers" },
  ],
  equipment: ["Leica RTC 360"], selectedEquipment: ["Leica RTC 360"], crew: "Chris Morel",
  grossRevenue: 6400, invoiced: false, paid: false, locationVenue: "Chelsea Piers",
};

export const HOLD_JOBS = [HOLD_JOB, HOLD_JOB_2];

export const holdsParams = () => {
  const params = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : new URLSearchParams();
  return { holds: params.get("holds") === "1", role: params.get("role") || "admin" };
};
